/**
 * One key per attempt. Sending the same key twice returns the first e-file
 * instead of creating a second one, so a double click cannot file twice.
 */
export function newIdempotencyKey(): string {
  const random =
    typeof crypto !== 'undefined' && 'randomUUID' in crypto
      ? crypto.randomUUID()
      : `${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 12)}`;
  return `web-${random}`;
}
